<template>
  <div>
    <form id='form-realms'>
      <div class="i-top-button-bar">
        <div class="button_container">
          <i-button
            :disabled="checkACL['/data/ts/realm/create']"
            @click.prevent.stop="showModal = true"
            :title="LANG.createRealm"
          >
            <i-icon :icon="'plus'" size="small"></i-icon>
            <span class="i-btn-label">{{ LANG.createRealm }}</span>
          </i-button>
        </div>
      </div>

      <div class="flow-auto">
        <table class="filelist table">
          <tbody>
            <tr
              v-for="realm in sortedRealms"
              :key="realm.name"
              @click='() => focusRealm(realm)'
              :class="rowDynamicClasses(realm.name)"
              class="pointer">
              <td class="name_cell">
                <a
                  @click.prevent
                  :title="realm.name">{{realm.name}}</a>
              </td>
              <td class="icon_cell">
                <TagRealmMenuOptions :realm="realm" />
              </td>
            </tr>
          </tbody>
        </table>

        <div class='footer'></div>
      </div>
    </form>

    <TagModalAddRealm v-model:show="showModal"/>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { mapState, mapGetters, mapActions } from 'vuex';

// Components
import Button from '@/components/lib/button/Button.vue';
import Icon from '@/components/lib/icon/Icon.vue';

import TagRealmMenuOptions from '@/components/tags/TagRealmMenuOptions.vue';
import TagModalAddRealm from './TagModalAddRealm.vue';

export default defineComponent({
  components: {
    TagModalAddRealm,
    TagRealmMenuOptions,
    [Button.name]: Button,
    [Icon.name]: Icon,
  },
  data() {
    return {
      showModal: false,
    };
  },
  created() {
    this.fetchRealms();
  },
  computed: {
    ...mapState(['LANG', 'tags']),
    ...mapGetters(['checkACL']),
    ...mapGetters('tags', ['sortedRealms']),
  },
  methods: {
    ...mapActions('tags', ['focusRealm', 'fetchRealms']),
    rowDynamicClasses(name) {
      return this.tags.focusedRealm === name
        ? 'i-state-active'
        : '';
    },
  },
});
</script>

<style scoped lang='scss'>
.i-btn-label {
  margin-left: 5px;
}

.flow-auto {
  height: calc(100% - 96px);
  overflow: auto;
}

.i-top-button-bar {
  padding: 10px;
}

.icon_cell div {
  display: inline-block;
}
</style>
